import { CloseOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import type { CustomTagProps } from '@/types/antd';
import { getTextColor } from '@/std/color';
import type { Marcador } from '../types/Marcador';

type SelectMarcadorTagProps = CustomTagProps & {
    marcadores?: Marcador[];
};

export function SelectMarcadorTag({
    closable,
    onClose,
    value,
    marcadores,
}: SelectMarcadorTagProps) {
    const marcador = marcadores?.find((marc) => marc.mar_idpk === value);

    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>): void => {
        event.preventDefault();
        event.stopPropagation();
    };

    const textColor = marcador?.mar_cor ? getTextColor(marcador.mar_cor) : 'white';

    return (
        <Tag
            closable={closable}
            closeIcon={<CloseOutlined style={{ color: textColor }} />}
            color={marcador?.mar_cor || 'gray'}
            disabled={false}
            onClose={onClose}
            onMouseDown={onPreventMouseDown}
            style={{
                color: textColor,
                marginInlineEnd: 4,
            }}
            variant='solid'
        >
            {marcador?.mar_titulo || 'Sem marcador'}
        </Tag>
    );
}
